/**
 * Module dependencies.
 */

import { AnimationController } from 'src/components/core/animations/animation-controller';
import { Button } from 'src/components/core/buttons/button';
import { ColorTheme } from 'src/components/core/buttons/button-theme-config';
import { Grid, SubGrid } from 'src/components/core/layout/grid-content';
import { Heading } from 'src/components/core/heading';
import { ReactNode } from 'react';
import { Section } from 'src/components/core/layout/section';
import { useTranslation } from 'next-i18next';
import verificar360Icon from 'src/assets/svgs/verificar360.svg';

/**
 * `icons` object.
 */

const icons = {
  verificar360: verificar360Icon
};

/**
 * `IconKey` type.
 */

type IconKey = keyof typeof icons;

/**
 * `Props` type.
 */

type Props = {
  button?: {
    colorTheme?: ColorTheme;
    href?: string;
    label: string;
  };
  className?: string;
  iconGrid?: ReactNode;
  iconKey?: IconKey;
  pageTranslationKey?: string;
  showLead?: boolean;
};

/**
 * Export `ServiceHeader` component.
 */

export const ServiceHeader = ({ button, className, iconGrid, iconKey, pageTranslationKey, showLead = true }: Props) => {
  const { t } = useTranslation(pageTranslationKey);

  return (
    <AnimationController staggerMobile style={{ overflow: 'hidden' }}>
      <Section className={className} hasNavbarOffset>
        <Grid>
          <SubGrid>
            <Heading
              asDescription={'p'}
              asLead={'p'}
              asTitle={'h2'}
              description={t('sections.header.description')}
              hasMaxWidth
              icon={iconKey ? icons[iconKey] : null}
              label={t('title')}
              lead={showLead ? t('sections.header.lead') : ''}
              offset
              style={{ marginBottom: 'var(--space-ms)' }}
              title={t('sections.header.title')}
            >
              {button && (
                <Button aria-label={button.label} colorTheme={button.colorTheme} href={button.href} size={'medium'}>
                  {button.label}
                </Button>
              )}
            </Heading>
          </SubGrid>
        </Grid>

        {iconGrid && iconGrid}
      </Section>
    </AnimationController>
  );
};
